<template>
    <div style="height: 100%">
      <div style="display: flex; width: 100%">
        <div style="width: 90%; height: 40px">
          <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
            <el-input v-model="formDatas.spName" style="width: 140px;" size="small" placeholder="请输入名称" clearable></el-input>
            <el-select size="small" v-model="formDatas.spStatus" clearable @change="partserch" placeholder="请选择" style="width: 130px">
              <!-- 1需求设计 2开发测试 3维护中 4暂停 5停止 -->
              <el-option label="需求设计" :value="1" key="1"></el-option>
              <el-option label="开发测试" :value="2" key="2"></el-option>
              <el-option label="维护中" :value="3" key="3"></el-option>
              <el-option label="暂停" :value="4" key="4"></el-option>
              <el-option label="停止" :value="5" key="5"></el-option>
            </el-select>
            <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
              style="margin-left: 10px">搜索</el-button>
          </el-row>
        </div>
        <div style="width: 10%; height: 40px">
          <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
            <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增</el-button>
          </el-row>
        </div>
      </div>
      <div class="tablemain">
        <div class="tablecss">
          <div style="width: 100%">
            <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
              :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
              :checkbox-option="checkboxOption" row-key-field-name="spId" :cellSelectionOption="cellSelectionOption"
              style="width: 100%" :editOption="editOption" />
              <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
          </div>
          <div class="table-pagination">
            <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
              :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
              @on-page-size-change="pageSizeChange" />
          </div>
        </div>
        <!-- 新增 -->
        <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑项目' : '新增项目'" :before-close="handleClose"
          :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
          <div class="demo-drawer__content" style="height: 90%;">
            <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
              <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                <el-form-item label="项目名称" prop="spName">
                  <el-input v-model="form.spName" style="width: 80%;" placeholder="请输入项目名称"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="spOrder">
                  <el-input v-model="form.spOrder" type="number" style="width: 80%;" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="项目描述" prop="spRemark">
                  <el-input v-model="form.spRemark" style="width: 80%;" placeholder="请输入项目描述"></el-input>
                </el-form-item>
                <el-form-item label="产品负责人" prop="spPm">
                  <el-input v-model="form.spPm" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="开发人员" prop="spDeveloper">
                  <el-input v-model="form.spDeveloper" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="其他参与人" prop="spParticipant">
                  <el-input v-model="form.spParticipant" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="访问地址" prop="spAddressAccess">
                  <el-input v-model="form.spAddressAccess" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="访问地址https" prop="spAddressAccessHttps">
                  <el-input v-model="form.spAddressAccessHttps" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="账号密码" prop="spAccount">
                  <el-input v-model="form.spAccount" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="开始时间" prop="spDateStart">
                  <el-input v-model="form.spDateStart" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="代码存储地址" prop="spSvnGit">
                  <el-input v-model="form.spSvnGit" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="数据库" prop="spSql">
                  <el-input v-model="form.spSql" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="开发端" prop="spPlatform">
                  <el-input v-model="form.spPlatform" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="相关账号信息" prop="spAccountRelated">
                  <el-input v-model="form.spAccountRelated" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="图片描述" prop="spQrcodeOneDes">
                  <el-input v-model="form.spQrcodeOneDes" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="图片" prop="spQrcodeOne">
                    <cj-upload ref="xlcjupload" @fileChange="spQrcodeOneUpfileChange" :filearr="fileList" :limit="1" style="margin: 10px 5px 5px;"></cj-upload>
                </el-form-item>
                <el-form-item label="图片描述" prop="spQrcodeTwoDes">
                  <el-input v-model="form.spQrcodeTwoDes" style="width: 80%;" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="图片" prop="spQrcodeTwo">
                    <cj-upload ref="xlcjupload" @fileChange="spQrcodeTwoUpfileChange" :filearr="fileListTwo" :limit="1" style="margin: 10px 5px 5px;"></cj-upload>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="demo-drawer__footer" style="margin-top: 10px;">
            <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
            <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
              确 定</el-button>
          </div>
        </el-drawer>
      </div>
      <el-dialog title="状态" :visible.sync="dialogStatus" width="70%" top="8vh">
        <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
            <div style="width: 100%; height: 100%; padding: 5%">
                <el-form ref="formDatas" :model="formDatas" label-position="top" label-width="150px" @submit.native.prevent>
                    <el-form-item label="状态" prop="dialogStatusValue">
                        <el-select v-model="dialogStatusValue" filterable placeholder="请选择">
                            <el-option v-for="item in statusAll || []" :label="item.name" :value="item.id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeStatus">取 消</el-button>
                    <el-button type="primary" @click="sureStatus">确 定</el-button>
                </span>
            </div>
        </div>
    </el-dialog>
     <!-- 详情 -->
     <el-dialog title="详情" :visible.sync="IsDetail" width="80%" top="8vh">
        <div style="max-height: 500px; overflow-y: scroll">
            <el-descriptions :column="2" border :labelStyle="{
                color: '#409EFF',
                textAlign: 'center',
                width: '14%',
                fontSize: '12px'
            }" :contentStyle="{ textAlign: 'center', width: '18%', fontSize: '12px' }">
                <el-descriptions-item label="项目名称">{{ DetailArr.spName }}</el-descriptions-item>
                <el-descriptions-item label="项目描述">{{ DetailArr.spRemark }}</el-descriptions-item>
                <el-descriptions-item label="状态">{{ DetailArr.spStatus }}</el-descriptions-item>
                <el-descriptions-item label="产品负责人">{{ DetailArr.spPm }}</el-descriptions-item>
                <el-descriptions-item label="开发人员">{{ DetailArr.spDeveloper }}</el-descriptions-item>
                <el-descriptions-item label="其他参与人">{{ DetailArr.spParticipant }}</el-descriptions-item>
                <el-descriptions-item label="访问地址">{{ DetailArr.spAddressAccess }}</el-descriptions-item>
                <el-descriptions-item label="访问地址https">{{ DetailArr.spAddressAccessHttps }}</el-descriptions-item>
                <el-descriptions-item label="账号密码">{{ DetailArr.spAccount }}</el-descriptions-item>
                <el-descriptions-item label="开始时间">{{ DetailArr.spDateStart }}</el-descriptions-item>
                <el-descriptions-item label="代码存储地址">{{ DetailArr.spSvnGit }}</el-descriptions-item>
                <el-descriptions-item label="数据库">{{ DetailArr.spSql }}</el-descriptions-item>
                <el-descriptions-item label="开发端">{{ DetailArr.spPlatform }}</el-descriptions-item>
                <el-descriptions-item label="相关账号信息">{{ DetailArr.spAccountRelated }}</el-descriptions-item>
                <el-descriptions-item label="图片描述">{{ DetailArr.spQrcodeOneDes }}</el-descriptions-item>
                <el-descriptions-item label="图片"> 
                    <el-image ref="scrImg" id="scrimg"
                        :src="DetailArr.spQrcodeOne" alt="" fit="scale-down" style="width: 100%;height: 50px;" :preview-src-list="[DetailArr.spQrcodeOne]">
                    </el-image>
                </el-descriptions-item>
                <el-descriptions-item label="图片描述">{{ DetailArr.spQrcodeTwoDes }}</el-descriptions-item>
                <el-descriptions-item label="图片"> 
                    <el-image ref="scrImg" id="scrimg"
                        :src="DetailArr.spQrcodeTwo" alt="" fit="scale-down" style="width: 100%;height: 50px;" :preview-src-list="[DetailArr.spQrcodeTwo]">
                    </el-image>
                </el-descriptions-item>

            </el-descriptions>

            <p style="width: 100%;text-align: center;margin: 10px 0;">里程碑</p>
            <div v-if="DetailArr.sysCjProjectMilestoneList" style="width: 100%;">
                <ve-table ref="vetable" v-if="DetailArr.sysCjProjectMilestoneList.length > 0" :columns="columnMilestone"
                    :table-data="DetailArr.sysCjProjectMilestoneList" :max-height="400" :border-x="true"
                    :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption" style="width: 100%;" />
            </div>
            <p style="width: 100%;text-align: center;margin: 10px 0;">数据库</p>
            <div v-if="DetailArr.sysCjProjectSqlList" style="width: 100%;">
                <ve-table ref="vetable" v-if="DetailArr.sysCjProjectSqlList.length > 0" :columns="columnSql"
                    :table-data="DetailArr.sysCjProjectSqlList" :max-height="400" :border-x="true"
                    :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption" style="width: 100%;" />
            </div>

        </div>
    </el-dialog>
    </div>
  </template>
  
  <script>
  
  import { getSysCjProjectList,getSysCjProjectDetails,addSysCjProject,updateSysCjProject,updateSysCjProjectStatus,deleteSysCjProject } from "../../api/api";
  export default {
    name: "",
    components: {},
    data() {
      return {
        IsDetail: false,
        dialog: false,
        edit: false,
        dialogStatus: false,
        dialogStatusValue: null,
        //状态(1需求设计 2开发测试 3维护中 4暂停 5停止)
        statusAll: [
            {id:1,name:"需求设计"},
            {id:2,name:"开发测试"},
            {id:3,name:"维护中"},
            {id:4,name:"暂停"},
            {id:5,name:"停止"},
        ],
        fileList: [],
        fileListTwo: [],
        DetailArr: [],
        form: {
          spName: '',
          spRemark: '',
          spPm: '',
          spDeveloper: '',
          spParticipant: '',
          spAddressAccess: '',
          spAddressAccessHttps: '',
          spAccount: '',
          spDateStart: '',
          spSvnGit: '',
          spSql: '',
          spPlatform: '',
          spAccountRelated: '',
          spQrcodeOneDes: '',
          spQrcodeOne: '',
          spQrcodeTwoDes: '',
          spQrcodeTwo: '',
        },
        rules: {},
        // 未编辑前的值
        lastValue: "",
        // 单元格编辑功能
        editOption: {
          beforeCellValueChange: ({ row, column, changeValue }) => {
            this.beforeCellValChange(row, column, changeValue);
          },
          afterCellValueChange: ({ row, column, changeValue }) => {
            this.afterCellValChange(row, column, changeValue);
          },
        },
        cellSelectionOption: {
          // disble cell selection
          enable: true,
        },
        totalCount: 100,
        pageIndex: 1,
        pageSize: 20,
        selectedRowKeysCollection: [],
        checkboxOption: {
          // 可控属性
          selectedRowKeys: [],
          // 行选择改变事件
          selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
            this.changeSelectedRowKeys(row, isSelected);
          },
          // 全选改变事件
          selectedAllChange: ({ isSelected, selectedRowKeys }) => {
            this.changeSelectAll(isSelected, selectedRowKeys);
          },
        },
        cellStyleOption: {
          headerCellClass: ({ column, rowIndex }) => {
            if (rowIndex === 0) {
              return "table-header-cell-class";
            }
          },
        },
        windheight: "",
        tableHight: 520,
        columns: [
          {
            field: "",
            key: "a",
            title: "序号",
            width: 50,
            align: "center",
            fixed: 'left',
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return ++rowIndex;
            },
          },
          {
            field: "spName",
            key: "spName",
            title: "项目名称",
            align: "center",
            fixed: 'left',
            edit: true,
            width: 100,
            renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                    <span><el-button size="mini" type="text" on-click={() => this.getDetail(row.spId)}>{row.spName}</el-button></span>
                );
            },
          },
          {
            field: "spStatus",
            key: "spStatus",
            title: "状态",
            width: 120,
            align: "center",
            fixed: 'left',
            edit: false,
            renderBodyCell: ({ row, column, rowIndex }, h) => {
                          return (
                            // 状态(1需求设计 2开发测试 3维护中 4暂停 5停止)
                              <span>
                                  {
                                      row.spStatus == 1 ? <el-tag type="warning">需求设计</el-tag> : 
                                      (row.spStatus == 2 ? <el-tag type="warning">开发测试</el-tag> : 
                                      (row.spStatus == 3 ? <el-tag type="success">维护中</el-tag> : 
                                      (row.spStatus == 4 ? <el-tag type="danger">暂停</el-tag> : 
                                      <el-tag type="danger">停止</el-tag>)))
                                  }
                                  {
                                    <el-button size="mini" type="text" on-click={() => this.handleStatus(row)} > 修改 </el-button>
                                  }
                              </span>
                          );
                      },
          },
          {
            field: "spSql",
            key: "spSql",
            title: "数据库",
            align: "center",
            fixed: 'left',
            edit: true,
            width: 100,
            // renderBodyCell: ({ row, column, rowIndex }, h) => {
            //     return (
            //         <span><el-button size="mini" type="text" on-click={() => this.getProjectSql(row.spId)}>{row.spSql}</el-button></span>
            //     );
            // },
          },
          {
            field: "spOrder",
            key: "spOrder",
            title: "排序",
            align: "center",
            edit: true,
            width: 90,
          },
          {
            field: "spRemark",
            key: "spRemark",
            title: "项目描述",
            align: "center",
            edit: true,
            width: 180,
          },
          {
            field: "spPm",
            key: "spPm",
            title: "产品负责人",
            align: "center",
            edit: true,
            width: 100,
          },
          {
            field: "spDeveloper",
            key: "spDeveloper",
            title: "开发人员",
            align: "center",
            edit: true,
            width: 100,
          },
          {
            field: "spParticipant",
            key: "spParticipant",
            title: "其他参与人",
            align: "center",
            edit: true,
            width: 160,
          },
          {
            field: "spAddressAccess",
            key: "spAddressAccess",
            title: "访问地址",
            align: "center",
            edit: true,
            width: 100,
          },
          {
            field: "spAddressAccessHttps",
            key: "spAddressAccessHttps",
            title: "访问地址",
            align: "center",
            edit: true,
            width: 100,
          },
          {
            field: "spAccount",
            key: "spAccount",
            title: "账号密码",
            align: "center",
            edit: true,
            width: 160,
          },
          {
            field: "spDateStart",
            key: "spDateStart",
            title: "开始时间",
            align: "center",
            edit: true,
            width: 100,
          },
          {
            field: "spSvnGit",
            key: "spSvnGit",
            title: "代码存储地址",
            align: "center",
            edit: true,
            width: 160,
          },
          {
            field: "spPlatform",
            key: "spPlatform",
            title: "开发端",
            align: "center",
            edit: true,
            width: 180,
          },
          {
            field: "spAccountRelated",
            key: "spAccountRelated",
            title: "相关账号信息",
            align: "center",
            edit: true,
            width: 200,
          },
          {
            field: "spQrcodeOneDes",
            key: "spQrcodeOneDes",
            title: "图片描述",
            align: "center",
            edit: true,
            width: 100,
          },
          {
            field: "spQrcodeOne",
            key: "spQrcodeOne",
            title: "图片",
            align: "center",
            width: 60,
            renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                    <span style="display:flex;align-items: center;">
                        <div style="width:100%;">
                            {
                                row.spQrcodeOne ? <el-image ref="scrImg" id="scrimg" src={row.spQrcodeOne} alt="" fit="scale-down" style="width: 100%;height: 30px;"
                                    previewSrcList={[row.spQrcodeOne]}></el-image> : <span></span>
                            }
                        </div>
                    </span>
                );
            },
          },
          {
            field: "spQrcodeTwoDes",
            key: "spQrcodeTwoDes",
            title: "图片描述",
            align: "center",
            edit: true,
            width: 100,
          },
          {
            field: "spQrcodeTwo",
            key: "spQrcodeTwo",
            title: "图片",
            align: "center",
            width: 60,
            renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                    <span style="display:flex;align-items: center;">
                        <div style="width:100%;">
                            {
                                row.spQrcodeTwo ? <el-image ref="scrImg" id="scrimg" src={row.spQrcodeTwo} alt="" fit="scale-down" style="width: 100%;height: 30px;"
                                    previewSrcList={[row.spQrcodeTwo]}></el-image> : <span></span>
                            }
                        </div>
                    </span>
                );
            },
          },
          { field: "createtime", key: "createtime", title: "创建时间", width: 160, edit: false, align: "center" },
          { field: "updatetime", key: "updatetime", title: "更新时间", width: 160, edit: false,align: "center" },
          {
            field: "",
            key: "d",
            title: "操作",
            width: 200,
            align: "center",
            fixed: 'right',
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span>
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.handleEdit(row)}
                  >
                    编辑
                  </el-button>
                  <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.handleDelete(row)}
                  >
                    删除
                  </el-button>
                </span>
              );
            },
          },
        ], 
        tableData: [],
        columnMilestone: [
          {
            field: "",
            key: "a",
            title: "序号",
            width: 50,
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return ++rowIndex;
            },
          },
          {
            field: "scpmType",
            key: "scpmType",
            title: "类型",
            width: 100,
            align: "center",
            edit: false,
            renderBodyCell: ({ row, column, rowIndex }, h) => {
                          return (
                              <span>
                                  {
                                      row.scpmType == 1 ? <el-tag type="success">记录</el-tag> :  <el-tag type="danger">里程碑</el-tag> 
                                  }
                              </span>
                          );
                      },
          },
          {
            field: "scpmName",
            key: "scpmName",
            title: "名称",
            width: 160,
            align: "center",
            edit: true,
          },
          {
            field: "scpmRemark",
            key: "scpmRemark",
            title: "描述",
            align: "center",
            edit: true,
          },
          { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
        ],
        columnSql: [
          {
            field: "",
            key: "a",
            title: "序号",
            width: 50,
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return ++rowIndex;
            },
          },
          {
            field: "scpsName",
            key: "scpsName",
            title: "备份标题",
            width: 160,
            align: "center",
            edit: true,
          },
          {
            field: "scpsbName",
            key: "scpsbName",
            title: "数据库",
            width: 160,
            align: "center",
            edit: true,
          },
          {
            field: "scpsPath",
            key: "scpsPath",
            title: "备份地址",
            align: "center",
            edit: false,
          },
          { field: "createtime", key: "createtime", title: "创建时间", width: 160, align: "center" },
        ],
        post: null,
        formDatas: {
          spId: null,
          spName: "",
          spStatus: null,
          dialogStatusValue: null,
          currentPage: 1,
          pageSize: 20,
        },
      };
    },
    activated() {
        this.getList();
      this.watchFlag = true;
      this.$nextTick(() => {
        this.windheight = this.$store.state.windheight;
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
      });
    },
    watch: {
      "$store.state.windheight"(val) {
        this.$nextTick(() => {
          if (this.watchFlag) {
            this.tableHight = val - 200 - val * 0.04;
          }
        });
      },
    },
    deactivated() {
      this.watchFlag = false;
    },
    created() {
      this.windheight = this.$store.state.windheight
      this.tableHight =  this.windheight - 200 -  this.windheight * 0.04;
      this.getList();
    },
    mounted() { },
    methods: {
        getProjectSql(id) {
            getSysCjProjectDetails({ spId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
            });
        },
        getDetail(id) {
            getSysCjProjectDetails({ spId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
            });
        },
        sureStatus(){
            updateSysCjProjectStatus({spId:this.formDatas.spId,spStatus:this.dialogStatusValue}).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                }
            })
            this.dialogStatus=false;
        },
        closeStatus(){
            this.dialogStatus=false;
        },
        handleStatus(row){
            console.log(row)
            this.formDatas.spId=row.spId;
            this.dialogStatusValue=row.spStatus;
            this.dialogStatus=true;
        },
        spQrcodeOneUpfileChange(file) {
          this.$set(this.form, 'spQrcodeOne', file[0])
          this.$message({
              type: "success",
              message: "上传成功!",
          });
      },
        spQrcodeTwoUpfileChange(file) {
          this.$set(this.form, 'spQrcodeTwo', file[0])
          this.$message({
              type: "success",
              message: "上传成功!",
          });
      },
      handleDelete(row){
        this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const s = {spIds:row.spId}
            console.log(s);
            deleteSysCjProject({spIds:row.spId}).then(res=>{
              if(res.data){
                this.$message({
              type: "success",
              message: "删除成功!",
            });
           
            this.partserch()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      },
      handleEdit(row){
        const data = JSON.parse(JSON.stringify(row))
        this.dialog = true;
        this.edit = true;
        this.$nextTick(()=>{
            this.form = data;
            this.form.spQrcodeOne = data.spQrcodeOne.split(',')
            this.form.spQrcodeTwo = data.spQrcodeTwo.split(',')
            if (data.spQrcodeOne.length > 0) {
            this.form.spQrcodeOne.forEach((item, index) => {
                const img = {
                name: item,
                url: item,
                }
                this.$set(this.fileList, index, img)
            })
            }
            if (data.spQrcodeTwo.length > 0) {
            this.form.spQrcodeTwo.forEach((item, index) => {
                const img = {
                name: item,
                url: item,
                }
                this.$set(this.fileListTwo, index, img)
            })
            }
        })
      },
      SureBtn() {
        if(!this.edit){
          this.$confirm("是否确定要新增, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            addSysCjProject(this.form).then(res=>{
              if(res.data){
                this.$message({
              type: "success",
              message: "新增成功!",
            });
            this.handleClose()
            this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
        }else{
          this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            updateSysCjProject(this.form).then(res=>{
              if(res.data){
                this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.handleClose()
            this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
        }
        
      },
      BoxOpen() {
        this.dialog = true;
  
      },
      // 关闭弹框
      handleClose() {
        this.dialog = false;
        this.edit = false;
        this.$refs['formRef'].resetFields();
      },
      // 修改单元格
      async beforeCellValChange(row, column, changeValue) {
        if (row[column.field] == changeValue) {
          return false;
        }
  
        this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var jsonObj = {};
            let formData = new FormData();
            formData.append(column.field, changeValue);
            formData.forEach((value, key) => (jsonObj[key] = value));
            jsonObj.spId = row.spId
            updateSysCjProject(jsonObj).then(res=>{
              this.$message({
              type: "success",
              message: "编辑成功!",
            });
            })
           
          })
          .catch(() => {
            this.lastValue = row[column.field];
            this.$nextTick(() => {
              this.tableData.forEach((item) => {
                for (let key in item) {
                  if (key == column.field && item[key] == changeValue) {
                    item[key] = this.lastValue;
                  }
                  console.log(key);
                }
              });
            });
            this.$message({
              type: "info",
              message: "已取消编辑",
            });
            return false;
          });
      },
      afterCellValChange(row, column, changeValue) {
        // console.log(" afterCellValChange", row, column, changeValue);
      },
      resetSelectedRowKeys() {
        console.log(this.checkboxOption.selectedRowKeys,this.selectedRowKeysCollection);
        this.checkboxOption.selectedRowKeys = [];
  
        const selectedRowKeysCollection = this.selectedRowKeysCollection;
  
        if (selectedRowKeysCollection.length) {
          this.tableData.forEach((item) => {
            if (selectedRowKeysCollection.indexOf(item.spId) > -1) {
              console.log(item);
              this.checkboxOption.selectedRowKeys.push(item.spId);
            }
          });
        }
      },
      changeSelectAll(isSelected, selectedRowKeys) {
        console.log(isSelected,selectedRowKeys);
        this.checkboxOption.selectedRowKeys = selectedRowKeys;
  
        if (isSelected) {
          this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
        } else {
          this.tableData.forEach((item,index) => {
            if (this.selectedRowKeysCollection.indexOf(item.spId) > -1) {
              this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.spId), 1);
            }
          });
        }
      },
      changeSelectedRowKeys(row, isSelected) {
        const rowKey = row.spId;
  
        if (isSelected) {
          this.checkboxOption.selectedRowKeys.push(rowKey);
          this.selectedRowKeysCollection.push(rowKey);
          console.log( this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
        } else {
          const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
          this.checkboxOption.selectedRowKeys.splice(index, 1);
          this.selectedRowKeysCollection.splice(index, 1);
        }
      },
      pageSizeChange(pageSize) {
      
        this.formDatas.pageSize = pageSize;
        this.partserch();
        
        
      },
      pageNumberChange(pageIndex) {
        console.log(pageIndex);
        this.formDatas.currentPage = pageIndex;
        getSysCjProjectList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
          this.resetSelectedRowKeys();
        });
      
      },
      partserch() {
        this.formDatas.currentPage = 1;
        getSysCjProjectList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
          this.resetSelectedRowKeys();
        });
      },
      getList() {
        getSysCjProjectList(this.formDatas).then((res) => {
          this.tableData = res.data;
          this.totalCount = res.total;
        });
      },
    },
  };
  </script>
  
  <style>
  .table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
  }
  
  .easetable::-webkit-scrollbar {
    display: none;
  }
  
  .ve-table-container {
    height: auto !important;
  }
  </style>
  